import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useParams } from 'react-router';
import { queryKeys } from '../../../../../../../../../../../queries/conversions';
import {
	usePagination,
	useStore,
} from '../../../../../../../../../../../utils/hooks';
import { ConversionsTableNew } from '../../../../../../../../../../presentational';
import { useConversionFilters } from '../FilterProvider';

export const Table = () => {
	const { getCampaignConversions } = useStore();
	const { campaignId } = useParams();
	const { state, update } = useConversionFilters();
	const [getPagination] = usePagination({ limit: state.limit || 10 });

	/**
	 * @todo make query to get conversions here
	 */
	const {
		isLoading,
		isRefetching,
		isError,
		data,
		error,
	} = useQuery(
		queryKeys.listConversions({ campaignId, ...state }),
		() => getCampaignConversions({ campaignId, ...state }),
		{ enabled: !!campaignId, refetchOnWindowFocus: false }
	);

	/**
	 * control pagination on table component
	 */
	const paginationConfig = {
		paginationServer: true,
		paginationDefaultPage: state.page || 1,
		paginationTotalRows: data?.conversions.count,
		paginationPerPage: state.limit || 10,
		onChangePage: (next) => {
			const { skip, page } = getPagination({ page: next });
			update({ skip, page });
		},
		onChangeRowsPerPage: (currentRowsPerPage, page) => {
			const { skip, limit } = getPagination({
				page,
				limit: currentRowsPerPage,
			});
			update({ skip, limit });
		},
	};

	return isError ? (
		error?.message
	) : (
		<ConversionsTableNew
			collection={data?.conversions.rows}
			progressPending={isLoading || isRefetching}
			{...paginationConfig}
		/>
	);
};
